var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_333_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2 1.89678L8.2 0H0L0 13.53L0.52 14.113H29.4116L30 13.5246V2.7L29.5 2.02309H10.5C10.3842 2.02309 10.2829 1.97791 10.2 1.89678Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015 0.015H8.19402L10.1895 1.9075C10.1895 1.90752 10.1895 1.90753 10.1896 1.90755C10.275 1.99114 10.38 2.03809 10.5 2.03809H29.4924L29.985 2.70494V13.5184L29.4054 14.098H0.526721L0.015 13.5243V0.015Z",
    stroke: "url(#paint0_linear_333_35)",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.015 0.015H8.19402L10.1895 1.9075C10.1895 1.90752 10.1895 1.90753 10.1896 1.90755C10.275 1.99114 10.38 2.03809 10.5 2.03809H29.4924L29.985 2.70494V13.5184L29.4054 14.098H0.526721L0.015 13.5243V0.015Z",
    stroke: "url(#paint1_linear_333_35)",
    strokeWidth: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_333_35",
    x: -23,
    y: -23,
    width: 76,
    height: 60.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_333_35"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_333_35",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_333_35",
    x1: -0.632321,
    y1: -1.69112,
    x2: 13.5163,
    y2: 11.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_333_35",
    x1: 32.2219,
    y1: 17.3296,
    x2: 23.9711,
    y2: 11.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTablet);
export default __webpack_public_path__ + "static/media/home_tablet.3383724f3a0a69c18604a45909775575.svg";
export { ForwardRef as ReactComponent };